import { render, staticRenderFns } from "./InstantAccess.vue?vue&type=template&id=34196f5c&scoped=true"
import script from "./InstantAccess.vue?vue&type=script&lang=js"
export * from "./InstantAccess.vue?vue&type=script&lang=js"
import style0 from "./InstantAccess.vue?vue&type=style&index=0&id=34196f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34196f5c",
  null
  
)

export default component.exports